import React from 'react'

function PrincipalVisita() {
  return (
    <div>
      asd
    </div>
  )
}

export default PrincipalVisita
